import axios from "axios";

const createEvals = (data) => {
  return axios
    .post(`${process.env.REACT_APP_API_BASE_URL}/evaluation/create`, data)
    .then((response) => {
      return response.data;
    });
};

const createCalibrage = async (data) => {
  return await axios
    .post(`${process.env.REACT_APP_API_BASE_URL}/calibrage/create`, data)
    .then((response) => {
      return response.data;
    });
};

const updateCalibrage = async (data, id) => {
  return await axios
    .put(`${process.env.REACT_APP_API_BASE_URL}/calibrage/update`, data)
    .then((response) => {
      return response.data;
    });
};

const allCalibs = (page, size) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/calibrage/list?page=${page}&size=${size}`
    )
    .then((response) => {
      return response.data;
    });
};

const getCalibsByTenantId = (page, size) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/calibrage/by-tenant?page=${page}&size=${size}`
    )
    .then((response) => {
      return response.data;
    });
};
const meCalibs = (page, size) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/calibrage/mesCalibs?page=${page}&size=${size}`
    )
    .then((response) => {
      return response.data;
    });
};
const meCalibsWithFilter = (page, size, statusList) => {
  const statusQuery = statusList.join(",");
  console.log("statusQuery=>", statusQuery);
  return axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/calibrage/mesCalibsWithFilter?page=${page}&size=${size}&statusList=${statusQuery}`
    )
    .then((response) => {
      return response.data;
    });
};
const oneCalibrage = (calibIdId) => {
  return axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/calibrage/get-one/${calibIdId}`)
    .then((response) => {
      return response.data;
    });
};

const allCalibsWithFilter = (page, size, statusList) => {
  const statusQuery = statusList.join(",");
  return axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/calibrage/listWithFilter?page=${page}&size=${size}&statusList=${statusQuery}`
    )
    .then((response) => {
      return response.data;
    });
};

const deactivateCalib = (calibId) => {
  return axios
    .put(
      `${process.env.REACT_APP_API_BASE_URL}/calibrage/activate-deactivate/${calibId}`
    )
    .then((response) => {
      return response.data;
    });
};

const search = (page, size, status, keyword) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/evaluation/search/by-tenant?page=${page}&size=${size}&status=${status}&keyword=${keyword}`
    )
    .then((response) => {
      return response.data;
    });
};

const searchMesEvals = (page, size, status, keyword) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_BASE_URL}/evaluation/searchMesEvals?page=${page}&size=${size}&status=${status}&keyword=${keyword}`
    )
    .then((response) => {
      return response.data;
    });
};
const LibererAcces = (calibId) => {
  return axios
    .put(
      `${process.env.REACT_APP_API_BASE_URL}/calibrage/release-access/${calibId}`
    )
    .then((response) => {
      return response.data;
    });
};
const PrendreAcces = (calibId) => {
  return axios
    .put(
      `${process.env.REACT_APP_API_BASE_URL}/calibrage/get-access/${calibId}`
    )
    .then((response) => {
      return response.data;
    });
};
export default {
  allCalibs,
  createEvals,
  oneCalibrage,
  meCalibs,
  search,
  deactivateCalib,
  allCalibsWithFilter,
  meCalibsWithFilter,
  getCalibsByTenantId,
  searchMesEvals,
  createCalibrage,
  LibererAcces,
  PrendreAcces,
  updateCalibrage,
};
